
import { Vue, Component, Prop } from "vue-property-decorator";
import { DesignProvider } from "@/types/design-library";
import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";
import { fold } from "fp-ts/Either";

import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton, TextInput }
})
export default class DesignLibraryPassword extends Vue {
  @Prop()
  provider?: DesignProvider | null;

  @Prop()
  compact?: boolean;

  password = "";
  passwordValid = true;
  checkedPassword = false;
  checkingPassword = false;

  async setPassword() {
    if (this.checkingPassword) return;

    this.checkingPassword = true;
    this.checkedPassword = false;

    const validated = pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_set_design_set_password",
        decoder: t.type({
          validated: t.boolean,
          message: t.string
        }),
        friendlyName: `Set Password For "${this.provider?.name}"`,
        dataToPost: {
          url: this.provider?.url,
          password: this.password
        },
        suppressErrorLogging: true
      }),
      fold(
        () => false,
        ({ validated }) => validated
      )
    );

    if (validated) {
      this.$emit("password-validated", this.password);
      this.passwordValid = true;
      this.checkedPassword = true;
    } else {
      this.checkingPassword = false;
      this.passwordValid = false;
      this.checkedPassword = true;
    }
  }
}
